import chatIcon from "../../assets/images/icons/chatIcon.png";
import guatusoIcon from "../../assets/images/icons/guatusoIcon.png";
import guatusoActiveIcon from "../../assets/images/icons/guatusoActiveIcon.png";
import losChilesIcon from "../../assets/images/icons/losChilesIcon.png";
import losChilesActiveIcon from "../../assets/images/icons/losChilesActiveIcon.png";
import upalaIcon from "../../assets/images/icons/upalaIcon.png";
import React, { useState } from 'react';
import LocationModal from "../locationModal/locationModal";
import { useNavigate } from "react-router-dom";
import ChatBot from "../chatBot/chatBot";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";
import { AnimatePresence, motion } from "framer-motion";
import { sideVariants } from '../../animation';
import { useEffect } from "react";

const CANTONS = {
    CHILES: "Los Chiles",
    GUATUSO: "Guatuso",
    UPALA: "Upala"
}

const LocationNavbar = ({callback, setShowChatNav, activeAnimationMap, setApplyOverlay, setModalOpen}) => {
  const locations = [
    {
      name: CANTONS.UPALA, src: upalaIcon, srcActive: upalaIcon,
      iconBgActive: "bg-[#014F59]",
    },
    {
      name: CANTONS.GUATUSO, src: guatusoIcon, srcActive: guatusoActiveIcon,
      iconBgActive: "bg-[#25593B]",
    },
    {
      name: CANTONS.CHILES, src: losChilesIcon, srcActive: losChilesActiveIcon,
      iconBgActive: "bg-[#06475D]",
    },
    {
      name: "Chat", src: chatIcon, srcActive: chatIcon, 
      iconBgActive: "bg-[#02F1A0]"
    }
  ]
  const { t } = useTranslation();
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [locationSelected, setLocationSelected] = useState("");
  const [locationDescription, setLocationDescription] = useState("");

    const cantonsMapping = {

        "Upala": {
            position: [-28.5, 0, -20.78],
            slogan: "Sorprendente de arriba a abajo",
            description: "text-upala"
        },
        "Guatuso": {
            position: [0.8, 0, 1.4],
            slogan: "Cuna del cacao",
            description: "text-guatuso"
        },
        "Los Chiles": {
            position: [22.75, 0, -15.6],
            slogan: "El cantón que sorprende",
            description: "text-los-chiles"
        },

    }

    const mobileCheck = () => {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  const showLocation = (name) => {
    if(name === "Chat"){
      callback(name);
      setShowLocationModal(false);
      setLocationSelected("");
      setShowChat(true);
      setModalOpen(true);
      setApplyOverlay(true);
      return;
    }

    setApplyOverlay(true);
    setModalOpen(true);
    setLocationDescription(cantonsMapping[name].description);
    setLocationSelected({
      locationName: name,
      locationSlogan : cantonsMapping[name].slogan
    });

    ReactGA.event({
      category : name,
      action: " Click Cantón",
      label: "Cantón",
      value: name
    });

    const camera = document.querySelector("#camera");
    const pivot = document.querySelector("#pivot");
    const cantonData = cantonsMapping[name];

    camera.components['orbit-controls'].data.enabled = false;

    const cameraAnimation = `property: position; from: ${camera.object3D.position.x} ${(mobileCheck()) ? '14' : '25'} ${camera.object3D.position.z}; to: ${cantonData.position[0]} ${(mobileCheck()) ? '14' : '25'} ${cantonData.position[2]}; dir: normal; dur: 2000; easing: easeOutQuad;`

    camera.setAttribute("animation", cameraAnimation);
    pivot.setAttribute("position", `${cantonData.position[0]} 4 ${cantonData.position[2]-6}`);

    setTimeout(() => {
        camera.components['orbit-controls'].dolly.position.set(cantonData.position[0], mobileCheck() ? 14 : 25, cantonData.position[2]);
        camera.components['orbit-controls'].data.enabled = true;
        setShowLocationModal(true);
    }, 2100);
  }

  useEffect(() => {
    if(!showLocationModal || !showChat){
      setApplyOverlay(false);
    }
  },[showLocationModal, showChat])

    return (
      <>
        <AnimatePresence >
          {activeAnimationMap && (
              <motion.div className="text-center text-black z-10 bg-[#FFFFFF] pt-4 pb-2 lg:rounded-t-3xl lg:w-2/5 w-full"
                initial="collapsed"
                  animate="open"
                  exit="collapsed"
                  variants={sideVariants}
                  transition= {{ delay: 2, duration: 1 }}
              >
                  <div className="container mx-auto grid grid-cols-4 justify-items-center">
                    {locations && locations.map((location, i) => {
                      return(
                        <div key={location.name} className="flex flex-col cursor-pointer items-center" onClick={() => showLocation(location.name)}>
                          <div className={`${locationSelected.locationName  === location.name ? location.iconBgActive : 'bg-[#E5ECFF]'} flex justify-center rounded-full w-14`} >
                            <img className={`${location.name  === "Chat" ? "": "p-1"} justify-self-center`} src={ locationSelected.locationName  === location.name ? location.srcActive : location.src} alt={location.name}/>
                          </div>
                          <h2 className="text-[#202945]">{location.name}</h2>
                        </div>
                      )
                    })
                    }
                  </div>
              </motion.div>
          )}
        </AnimatePresence>
          {showLocationModal && 
            <LocationModal setShowLocationModal={setShowLocationModal} setLocationSelected={setLocationSelected} 
              name={locationSelected.locationName}
              subtitle={locationSelected.locationSlogan}
              text={t(`location.${locationDescription}`)}
              setModalOpen={setModalOpen}
            />
          }
          {showChat &&
            <ChatBot setShowChat={setShowChat} setShowChatNav={setShowChatNav} setModalOpen={setModalOpen}/>
          }
      </>
    );
  };
  
  export default LocationNavbar;